export default function LogoMark({ className = "h-7 w-auto" }) {
  return <img src="/logo-green.png" alt="Fundprints logo" className={className} />;
}
